(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["delivery-check"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-dlv]');
    if (!root) return;
    const form = root.querySelector('[data-dlv-form]');
    const cfgEl = root.querySelector('[data-dlv-config]');
    if (!form || !cfgEl) return;

    const cfg = JSON.parse(cfgEl.textContent);
    const $ = (s) => root.querySelector(s);
    const resultEl = $('[data-dlv-result]');
    const submitBtn = $('[data-dlv-submit]');
    const zipInput = form.elements.zip;

    let rates = null;
    let cart = null;
    let current = null;

    const money = (cents) => {
      const value = (cents / 100).toFixed(2);
      const plain = value.replace(/\.00$/, '');
      return cfg.moneyFormat
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toLocaleString('en-MY'))
        .replace(/\{\{\s*amount\s*\}\}/, Number(value).toLocaleString('en-MY', { minimumFractionDigits: 2 }))
        .replace(/\{\{\s*[a-z_]+\s*\}\}/, plain);
    };

    const isFee = (item) => item.product_id === cfg.feeProductId;
    const subtotal = () => (cart ? cart.items.filter((i) => !isFee(i)).reduce((s, i) => s + i.final_line_price, 0) : 0);

    function findZone(zip) {
      if (!rates || !/^\d{5}$/.test(zip)) return null;
      if (rates.exact && rates.exact[zip]) return rates.exact[zip];
      const n = parseInt(zip, 10);
      for (const [from, to, zone] of rates.ranges || []) {
        if (n >= from && n <= to) return zone;
      }
      return rates.default || null;
    }

    function render() {
      const zip = zipInput.value.trim();
      $('[data-dlv-subtotal]').textContent = money(subtotal());
      current = null;
      resultEl.className = 'dlv__result';
      resultEl.textContent = '';

      if (zip.length === 5) {
        const zone = findZone(zip);
        const tier = zone && rates.zones && rates.zones[zone];
        const variant = tier && cfg.variants.find((v) => v.title.trim().toLowerCase() === String(tier.variant).trim().toLowerCase());
        if (variant && variant.available) {
          current = { zone, tier, variant };
          resultEl.classList.add('dlv__result--ok');
          resultEl.textContent = (tier.label ? tier.label + ' — ' : '') + 'Delivery: ' + money(variant.price);
        } else {
          resultEl.classList.add('dlv__result--error');
          resultEl.textContent = cfg.notDeliverableText;
        }
      }

      $('[data-dlv-fee]').textContent = current ? money(current.variant.price) : '—';
      $('[data-dlv-total]').textContent = money(subtotal() + (current ? current.variant.price : 0));
      submitBtn.disabled = !(current && form.elements.state.value && form.elements.city.value.trim());
    }

    async function postJSON(url, body) {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      if (!res.ok) throw new Error(url + ' ' + res.status);
      return res.json();
    }

    function prefill() {
      const a = (cart && cart.attributes) || {};
      if (a['Delivery State']) form.elements.state.value = a['Delivery State'];
      if (a['Delivery City']) form.elements.city.value = a['Delivery City'];
      if (a['Delivery Postcode']) zipInput.value = a['Delivery Postcode'];
    }

    zipInput.addEventListener('input', () => {
      zipInput.value = zipInput.value.replace(/\D/g, '').slice(0, 5);
      render();
    });
    form.elements.state.addEventListener('change', render);
    form.elements.city.addEventListener('input', render);

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      render();
      if (!current) return;

      submitBtn.disabled = true;
      const originalText = submitBtn.textContent;
      submitBtn.textContent = 'Please wait…';

      try {
        cart = await (await fetch('/cart.js')).json();

        const updates = {};
        cart.items.filter(isFee).forEach((i) => (updates[i.key] = 0));
        const zip = zipInput.value.trim();
        await postJSON('/cart/update.js', {
          updates,
          attributes: {
            'Delivery Country': 'Malaysia',
            'Delivery State': form.elements.state.value,
            'Delivery City': form.elements.city.value.trim(),
            'Delivery Postcode': zip,
            'Delivery Zone': current.zone
          }
        });

        await postJSON('/cart/add.js', { items: [{ id: current.variant.id, quantity: 1 }] });

        const q = new URLSearchParams({
          'checkout[shipping_address][country]': 'Malaysia',
          'checkout[shipping_address][province]': form.elements.state.value,
          'checkout[shipping_address][city]': form.elements.city.value.trim(),
          'checkout[shipping_address][zip]': zip
        });
        window.location.href = '/checkout?' + q.toString();
      } catch (err) {
        console.error('[delivery-check]', err);
        resultEl.className = 'dlv__result dlv__result--error';
        resultEl.textContent = 'Something went wrong. Please try again.';
        submitBtn.textContent = originalText;
        submitBtn.disabled = false;
      }
    });

    Promise.all([
      fetch(cfg.ratesUrl).then((r) => r.json()),
      fetch('/cart.js').then((r) => r.json())
    ])
      .then(([r, c]) => {
        rates = r;
        cart = c;
        prefill();
        render();
      })
      .catch((err) => {
        console.error('[delivery-check] could not load rates', err);
        resultEl.className = 'dlv__result dlv__result--error';
        resultEl.textContent = 'Delivery rates could not be loaded. Please refresh the page.';
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class HeroCarousel {
      constructor(el) {
        this.el = el;
        this.slides = Array.from(el.querySelectorAll('[data-slide]'));
        this.segs = Array.from(el.querySelectorAll('.hero-carousel__nav-seg'));
        this.prevBtn = el.querySelector('.hero-carousel__arrow--prev');
        this.nextBtn = el.querySelector('.hero-carousel__arrow--next');
        this.current = 0;
        this.autoplay = el.dataset.autoplay === 'true';
        this.speed = parseInt(el.dataset.autoplaySpeed, 10) || 4500;
        this.timer = null;

        this.bind();
        this.updateRatio();
        if (this.autoplay && this.slides.length > 1) this.play();
      }

      bind() {
        this.segs.forEach((seg, i) => seg.addEventListener('click', () => this.goTo(i)));
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goTo(this.current - 1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goTo(this.current + 1));
        this.el.addEventListener('mouseenter', () => this.pause());
        this.el.addEventListener('mouseleave', () => { if (this.autoplay) this.play(); });
      }

      goTo(index) {
        const total = this.slides.length;
        if (total === 0) return;
        this.current = (index + total) % total;

        this.slides.forEach((s, i) => s.classList.toggle('is-active', i === this.current));

        this.segs.forEach((seg, i) => {
          seg.classList.toggle('is-active', i === this.current);
          const fill = seg.querySelector('.hero-carousel__nav-fill');
          if (!fill) return;
          fill.style.animation = 'none';
          if (i === this.current) {
            requestAnimationFrame(() => {
              fill.style.animation = `heroCarouselFill ${this.speed}ms linear forwards`;
            });
          } else {
            fill.style.width = '0%';
          }
        });

        this.updateRatio();
        if (this.autoplay) this.play();
      }

      updateRatio() {
        const slide = this.slides[this.current];
        if (!slide) return;
        this.el.style.setProperty('--hero-carousel-ratio-desktop', slide.dataset.ratioDesktop || '1.78');
        this.el.style.setProperty('--hero-carousel-ratio-mobile', slide.dataset.ratioMobile || '0.8');
      }

      play() {
        clearTimeout(this.timer);
        if (this.slides.length < 2) return;
        this.timer = setTimeout(() => this.goTo(this.current + 1), this.speed);
      }

      pause() {
        clearTimeout(this.timer);
      }
    }

    function init() {
      document.querySelectorAll('[data-hero-carousel]').forEach((el) => {
        if (el.heroCarouselInstance) return;
        el.heroCarouselInstance = new HeroCarousel(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotsport-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHotspot(section) {
      const points = section.querySelectorAll('[data-hotspot]');
      if (!points.length) return;

      points.forEach((point) => {
        const toggle = point.querySelector('[data-hotspot-toggle]');
        if (!toggle) return;

        toggle.addEventListener('click', (event) => {
          event.stopPropagation();

          const wasActive = point.classList.contains('is-active');

          points.forEach((item) => {
            item.classList.remove('is-active');
          });

          if (!wasActive) {
            point.classList.add('is-active');
          }
        });
      });

      document.addEventListener('click', () => {
        points.forEach((point) => {
          point.classList.remove('is-active');
        });
      });
    }

    function init() {
      document
        .querySelectorAll('[data-hotspot-section]')
        .forEach((section) => {
          if (section.hotspotInit) return;

          section.hotspotInit = true;
          initHotspot(section);
        });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(wrap) {
      const track = wrap.querySelector('[data-track]');
      const thumb = wrap.querySelector('[data-thumb]');
      const prevBtn = wrap.querySelector('[data-arrow="prev"]');
      const nextBtn = wrap.querySelector('[data-arrow="next"]');

      if (!track) return;

      function updateThumb() {
        if (!thumb) return;

        const ratio = track.clientWidth / track.scrollWidth;
        const maxScroll = track.scrollWidth - track.clientWidth || 1;
        const scrollRatio = track.scrollLeft / maxScroll;

        thumb.style.width = `${ratio * 100}%`;
        thumb.style.left = `${scrollRatio * (100 - ratio * 100)}%`;
      }

      function scrollByCard(direction) {
        const card = track.querySelector('.pcarousel__card');
        if (!card) return;

        const amount = card.getBoundingClientRect().width + 16;

        track.scrollBy({
          left: direction * amount,
          behavior: 'smooth'
        });
      }

      track.addEventListener('scroll', updateThumb);
      window.addEventListener('resize', updateThumb);

      if (prevBtn) {
        prevBtn.addEventListener('click', (event) => {
          event.preventDefault();
          scrollByCard(-1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', (event) => {
          event.preventDefault();
          scrollByCard(1);
        });
      }

      updateThumb();
    }

    function init() {
      document.querySelectorAll('.pcarousel').forEach((wrap) => {
        if (wrap.pcarouselInit) return;

        wrap.pcarouselInit = true;
        initCarousel(wrap);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class SaleCarousel {
      constructor(element) {
        this.element = element;
        this.slides = Array.from(
          element.querySelectorAll('[data-slide]')
        );
        this.prevButton = element.querySelector(
          '.sale-banner__arrow--prev'
        );
        this.nextButton = element.querySelector(
          '.sale-banner__arrow--next'
        );

        this.current = 0;
        this.autoplay =
          element.dataset.autoplay === 'true';
        this.speed =
          parseInt(element.dataset.autoplaySpeed, 10) || 5000;
        this.timer = null;

        if (this.prevButton) {
          this.prevButton.addEventListener('click', () => {
            this.goTo(this.current - 1);
          });
        }

        if (this.nextButton) {
          this.nextButton.addEventListener('click', () => {
            this.goTo(this.current + 1);
          });
        }

        this.element.addEventListener('mouseenter', () => {
          this.pause();
        });

        this.element.addEventListener('mouseleave', () => {
          if (this.autoplay) {
            this.play();
          }
        });

        if (this.autoplay && this.slides.length > 1) {
          this.play();
        }
      }

      goTo(index) {
        const total = this.slides.length;

        if (!total) return;

        this.current = (index + total) % total;

        this.slides.forEach((slide, slideIndex) => {
          slide.classList.toggle(
            'is-active',
            slideIndex === this.current
          );
        });

        if (this.autoplay) {
          this.play();
        }
      }

      play() {
        this.pause();

        if (!this.autoplay || this.slides.length <= 1) {
          return;
        }

        this.timer = window.setInterval(() => {
          this.goTo(this.current + 1);
        }, this.speed);
      }

      pause() {
        if (!this.timer) return;

        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    function initCountdown(element) {
      const endDate = new Date(element.dataset.countdown);

      if (Number.isNaN(endDate.getTime())) return;

      const daysElement =
        element.querySelector('[data-cd-days]');
      const hoursElement =
        element.querySelector('[data-cd-hours]');
      const minutesElement =
        element.querySelector('[data-cd-minutes]');
      const secondsElement =
        element.querySelector('[data-cd-seconds]');

      function pad(value) {
        return String(value).padStart(2, '0');
      }

      let interval = null;

      function tick() {
        const difference =
          endDate.getTime() - Date.now();

        if (difference <= 0) {
          [
            daysElement,
            hoursElement,
            minutesElement,
            secondsElement
          ].forEach((node) => {
            if (node) {
              node.textContent = '00';
            }
          });

          if (interval) {
            window.clearInterval(interval);
          }

          return;
        }

        const days = Math.floor(
          difference / (1000 * 60 * 60 * 24)
        );
        const hours = Math.floor(
          (difference / (1000 * 60 * 60)) % 24
        );
        const minutes = Math.floor(
          (difference / (1000 * 60)) % 60
        );
        const seconds = Math.floor(
          (difference / 1000) % 60
        );

        if (daysElement) {
          daysElement.textContent = pad(days);
        }

        if (hoursElement) {
          hoursElement.textContent = pad(hours);
        }

        if (minutesElement) {
          minutesElement.textContent = pad(minutes);
        }

        if (secondsElement) {
          secondsElement.textContent = pad(seconds);
        }
      }

      tick();

      interval = window.setInterval(tick, 1000);
    }

    function init(root = document) {
      root
        .querySelectorAll('[data-sale-carousel]')
        .forEach((element) => {
          if (element.saleCarouselInit) return;

          element.saleCarouselInit = true;

          new SaleCarousel(element);
        });

      root
        .querySelectorAll('[data-countdown]')
        .forEach((element) => {
          if (element.countdownInit) return;

          element.countdownInit = true;

          initCountdown(element);
        });
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => init()
      );
    } else {
      init();
    }

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        init(event.target);
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tow-columns-banners"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTcb(wrap) {
      const track = wrap.querySelector('[data-tcb-track]');
      const dots = wrap.querySelectorAll(
        '[data-tcb-dots] .tcb__dot'
      );

      if (!track || !dots.length) return;

      let ticking = false;

      function updateDots() {
        const banners = track.querySelectorAll('.tcb__banner');

        if (!banners.length) return;

        let closestIndex = 0;
        let closestDistance = Infinity;

        banners.forEach((banner, index) => {
          const distance = Math.abs(
            banner.offsetLeft - track.scrollLeft
          );

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        dots.forEach((dot, index) => {
          dot.classList.toggle(
            'is-active',
            index === closestIndex
          );
        });

        ticking = false;
      }

      track.addEventListener(
        'scroll',
        function () {
          if (ticking) return;

          ticking = true;

          window.requestAnimationFrame(updateDots);
        },
        { passive: true }
      );

      updateDots();
    }

    function init() {
      document.querySelectorAll('.tcb').forEach((wrap) => {
        if (wrap.dataset.tcbInitialized === 'true') return;

        wrap.dataset.tcbInitialized = 'true';

        initTcb(wrap);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        init
      );
    } else {
      init();
    }

    document.addEventListener(
      'shopify:section:load',
      init
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
